export const bufferToDataUrl = (input: { data: Buffer; format: string }) => {
  return `data:${input.format};base64,${input.data.toString('base64')}`;
};
